import script from "./ProcessWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProcessWindow.vue?vue&type=script&setup=true&lang=ts"

import "./ProcessWindow.vue?vue&type=style&index=0&id=c4450d30&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4450d30"]])

export default __exports__